import { useEffect } from 'react';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { GetClientDataResultType } from '~/store/apis/dtos/clientData/clientData.dto';
import {
  setApplicationUuid,
  setClientId,
  setQCode,
} from '~/store/slices/updateApplication/updateApplication.slice';

type UseAddClientDataToStateProps = {
  qCode: string | undefined;
  clientData: GetClientDataResultType | undefined;
};
export const useAddClientDataToState = ({
  qCode,
  clientData,
}: UseAddClientDataToStateProps) => {
  const dispatch = useAppDispatch();

  // clientData
  useEffect(() => {
    if (!clientData) return;

    const { applicationUuid, clientId } = clientData;

    if (applicationUuid) {
      dispatch(setApplicationUuid(applicationUuid));
    }
    dispatch(setClientId(clientId));
  }, [clientData, dispatch]);

  // qCode
  useEffect(() => {
    if (!qCode) return;

    dispatch(setQCode(qCode));
  }, [qCode, dispatch]);
};
